import React, { Component } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Row,
  Col,
  InputGroup,
  InputGroupText,
  Input,
  Alert,
} from "reactstrap";

import { FetchData, UploadFile } from "./utils/DataFetch";
import { GetCookie, Timeout } from "./utils/Common";

import DeleteIcon from '../images/delete.png';

import AddIcon from "../images/add.png";
import { WorkOrderAddJobTableDefault } from "./WorkOrderAddJobTableDefault";

const WORK_ORDER_UPDATE_TYPES = new Set([
  "Authorization",
  "To Booking Dept",
  "To Auth Dept",
  "To Conf Dept",
  "Provider Conf",
  "Int Cancelation",
  "Int Final Conf",
  "Claimant Confirmed",
  "Remote Prov Conf",
  "Remote Int Conf",
  "Remote Clm Conf",
  "Schedule Change",
]);

export class WorkOrderAddJobNotes extends Component {
  static displayName = WorkOrderAddJobNotes.name;

  constructor(props) {
    super(props);

    this.user = JSON.parse(GetCookie("user"));

    this.state = {
      alert: props.alert,
      model: props.model,
    };

    this.onSave = this.onSave.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSaveEventSuccess = this.handleSaveEventSuccess.bind(this);
    this.handleFileChange = this.handleFileChange.bind(this);
    this.handleDeleteFile = this.handleDeleteFile.bind(this);
    this.addJobHistory = this.addJobHistory.bind(this);
    this.handleRemove = this.handleRemove.bind(this);
    this.keydownHandler = this.keydownHandler.bind(this);
    this.renderJobNotes = this.renderJobNotes.bind(this);
  }

  componentDidMount() {
    document.addEventListener("keydown", this.keydownHandler);
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.keydownHandler);
  }

    handleChange(e) {
    let model = { ...this.state.model };
    model[e.target.name] = e.target.value;

    this.setState({ model });
  }

  handleSaveEventSuccess(alert) {
    this.setState(
      {
        alert: {
          color: alert.color,
          message: alert.message,
          isOpen: true,
        },
      },
      () => {
        window.setTimeout(() => {
          this.setState({ alert: { isOpen: false } });
        }, Timeout(alert.message));
      }
    );
  }

  handleFileChange(e) {
    let model = { ...this.state.model };
    model.FileName = e.target.files[0].name;
    model.FormFile = e.target.files[0];

    this.setState({ model });
  }

  handleDeleteFile() {
    this.fileUpload.value = null;

    let model = { ...this.state.model };
    model.FileName = '';
    model.FileLocation = '';

    this.setState({ model });
  }

  handleRemove(index) {
    let model = { ...this.state.model };

    if (model.JobHistory.length === 1) model.JobHistory = [];
    else {
      model.JobHistory.splice(index, 1);
    }

    this.setState({ model });
  }

  addJobHistory() {
    const isAttachment = this.cboType.value === 'Attachment';
    const model = { ...this.state.model };

    model.JobHistory.push({
      Type: this.cboType.value,
      Description: this.txtDescription.value,
      FileName: isAttachment ? this.state.model.FileName || '' : '',
      FormFile: isAttachment ? this.state.model.FormFile : null,
    });

    this.setState({ model }, () => {
      this.cboType.value = '';
      this.txtDescription.value = '';
      if (isAttachment) {
        this.fileUpload && (this.fileUpload.value = null);
        model.FileName = '';
        model.FormFile = null;
      }
    });
  }

  mapWorkOrderApiToModel(data) {
    return {
      EventType: "update",
      JobNum: data.jobNum,
      JobId: data.jobId,
      JobDateTime: data.jobDateTime,
      JobTime: data.jobTime,
      FinishTime: data.finishTime,
      FinishTimeString:
        data.finishTimeString === null ? null : data.finishTimeString,
      FollowupDate: data.followupDate,
      ProvId: data.provId,
      ProviderName: data.providerName,
      ProvEmail: data.provEmail,
      ConfCallNote: data.confCallNote,
      AptName: data.aptName,
      AptStreet: data.aptStreet,
      AptCity: data.aptCity,
      AptState: data.aptState,
      AptZip: data.aptZip,
      AptPhone: data.aptPhone,
      AptDirection: data.aptDirection,
      FailedFlg: data.failedFlg,
      CallerNote: data.callerNote,
      InvoiceNote: data.invoiceNote,
      IntCheckDate: data.intCheckDate,
      IntCheckNum: data.intCheckNum,
      InvoicedFlg: data.invoicedFlg,
      IntFinalConfEmailSentFlg:
        data.IntFinalConfEmailSentFlg ??
        data.intFinalConfEmailSentFlg ??
        data.intFinalConfEmailSendFlg ??
        false,
      JobTotal: data.jobTotal,
      JobDiscount: data.jobDiscount,
      IntFee: data.intFee === null ? null : parseInt(data.intFee, 10),
      IntFeeOther:
        data.intFeeOther === null ? null : parseInt(data.intFeeOther, 10),
      IntOTFee: data.intOTFee === null ? null : parseInt(data.intOTFee, 10),
      IntFeeNote: data.intFeeNote,
      TransportationFlg: data.transportationFlg,
      TransConfFlg: data.transConfFlg,
      IntConfFlg: data.intConfFlg,
      AppointmentTypeId: data.appointmentTypeId,
      CallerType: data.callerType,
      ProvConfFlg: data.provConfFlg,
      ClmConfFlg: data.clmConfFlg,
      IsDeletedFlg: data.isDeletedFlg,
      BillReviewedFlg: data.billReviewedFlg,
      AuditFlg: data.auditFlg,
      PurpleReportFlg: data.purpleReportFlg,
      RepAuthorizedFlg: data.repAuthorizedFlg,
      SelectedFlg: data.selectedFlg,
      ClmId: data.clmId,
      ClmFirstName: data.clmFirstName,
      ClmLastName: data.clmLastName,
      ClmClaimNumber: data.clmClaimNumber,
      ClmClaimNumberNoDash: data.clmClaimNumberNoDash,
      ClmPhone: data.clmPhone,
      ClmDateOfLoss: data.clmDateOfLoss,
      ClmDateOfInjury: data.clmDateOfInjury,
      ClmDateOfInjuryStart: data.clmDateOfInjuryStart,
      ClmDateOfInjuryEnd: data.clmDateOfInjuryEnd,
      ClmNote: data.clmNote,
      ClmDOB: data.clmDOB,
      ClmInsuredParty: data.clmInsuredParty,
      ClmEmployer: data.clmEmployer,
      ClmInvoiceCaption: data.clmInvoiceCaption,
      ClmLanguage: data.clmLanguage,
      ClmWCABNumber: data.clmWCABNumber,
      ClmInvoiceType: data.clmInvoiceType,
      ClmStreet: data.clmStreet,
      ClmCity: data.clmCity,
      ClmState: data.clmState,
      ClmZip: data.clmZip,
      ClmSSN: data.clmSSN,
      ClmOrderedByName: data.clmOrderedByName,
      ClmDiagnosis: data.clmDiagnosis,
      ClmEmail: data.clmEmail,
      ClmHasAttorneyFlg: data.clmHasAttorneyFlg,
      RepId: data.repId,
      RepFirstName: data.repFirstName,
      RepLastName: data.repLastName,
      RepPhone: data.repPhone,
      RepEmail: data.repEmail,
      ClientId: data.clientId,
      ClientAbbrv: data.clientAbbrv,
      ClientName: data.clientName,
      ClientStreet: data.clientStreet,
      ClientStreet2: data.clientStreet2,
      ClientCity: data.clientCity,
      ClientState: data.clientState,
      ClientZip: data.clientZip,
      ClientMailStreet: data.clientMailStreet,
      ClientMailStreet2: data.clientMailStreet2,
      ClientMailCity: data.clientMailCity,
      ClientMailState: data.clientMailState,
      ClientMailZip: data.clientMailZip,
      ClientPhone: data.clientPhone,
      ClientPhoneFax: data.clientPhoneFax,
      ClientPhone2: data.clientPhone2,
      ClientEmail: data.clientEmail,
      ClientInactiveFlg: data.clientInactiveFlg,
      IntId: data.intId,
      IntLastName: data.intLastName,
      IntFirstName: data.intFirstName,
      IntCellTxt: data.intCellTxt,
      IntPhoneOnly: data.intPhoneOnly,
      IntEmail: data.intEmail,
      IntNote: data.intNote,
      InHouseFlg: data.inHouseFlg,
      IntCity: data.intCity,
      IntStreet: data.intStreet,
      IntState: data.intState,
      IntZip: data.intZip,
      DBA: data.dDBA,
      Rate: data.rate,
      HourMinimum: data.hourMinimum,
      Prorate: data.prorate,
      BankRoute: data.bankRoute,
      BankAccount: data.bankAccount,
      IntSSINumber: data.intSSINumber,
      FirstName: data.firstName,
      LastName: data.lastName,
      UserType: data.userType,
      UserIntId: data.userIntId,
      CreateDateTime: data.createDateTime,
      CreateByUserId: data.createByUserId,
      UpdateDateTime: data.updateDateTime,
      UpdateByUserId: data.updateByUserId,
      RemIntFlg: data.remIntFlg,
      RemClaimFlg: data.remClaimFlg,
      RemProvFlg: data.remProvFlg,
      RemFinalFlg: data.remFinalFlg,
      RemType: data.remType,
      RemTypeDesc: data.remTypeDesc,
      RemHost: data.remHost,
      RemHostDesc: data.remHostDesc,
      CreatedBy: data.createdBy,
      UpdatedBy: data.updatedBy,
      MyJobTJobHistory: data.myJobTJobHistory,
      MyJobWaitingOnCallBack: data.myJobWaitingOnCallBack,
      JobBalance: data.jobBalance,
      WorkFlowId: data.workFlowId,
      JobTypeName: data.jobTypeName,
    };
  }

  applyJobHistoryTypeToModel(model, historyType) {
    if (historyType === "Authorization") {
      model.RepAuthorizedFlg = true;
    } else if (historyType === "To Booking Dept") {
      model.WorkFlowId = "Booking";
    } else if (historyType === "To Auth Dept") {
      model.WorkFlowId = "Authorization";
    } else if (historyType === "To Conf Dept") {
      model.WorkFlowId = "Confirmation";
    } else if (historyType === "Provider Conf") {
      model.ProvConfFlg = true;
    } else if (historyType === "Int Cancelation") {
      model.IntConfFlg = false;
    } else if (historyType === "Int Final Conf") {
      model.IntConfFlg = true;
    } else if (historyType === "Claimant Confirmed") {
      model.ClmConfFlg = true;
    } else if (historyType === "Remote Prov Conf") {
      model.RemProvFlg = true;
    } else if (historyType === "Remote Int Conf") {
      model.RemIntFlg = true;
    } else if (historyType === "Remote Clm Conf") {
      model.RemClaimFlg = true;
    } else if (historyType === "Schedule Change") {
      model.RepAuthorizedFlg = false;
      model.IntConfFlg = false;
      model.ProvConfFlg = false;
    }

    return model;
  }

  getWorkOrderUpdateTypes(jobHistory) {
    return (jobHistory || [])
      .map((history) => history.Type)
      .filter((type) => WORK_ORDER_UPDATE_TYPES.has(type));
  }

  async preloadWorkOrders(jobIds) {
    const results = await Promise.all(
      jobIds.map(async (jobId) => {
        const data = await FetchData(
          "/getworkorder?jobId=" + jobId,
          "POST",
          this.user.token,
          null,
        );

        if (!data) {
          return { jobId, error: `Unable to load workorder ${jobId}` };
        }

        return { jobId, model: this.mapWorkOrderApiToModel(data) };
      }),
    );

    const failure = results.find((result) => result.error);
    if (failure) {
      return { error: failure.error };
    }

    const workOrdersById = {};
    results.forEach((result) => {
      workOrdersById[result.jobId] = result.model;
    });

    return { workOrdersById };
  }

  async updateWorkOrder(jobId, historyTypes, workOrderModel) {
    if (!workOrderModel) {
      return `Unable to load workorder ${jobId}`;
    }

    let model = { ...workOrderModel };
    historyTypes.forEach((historyType) => {
      model = this.applyJobHistoryTypeToModel(model, historyType);
    });
    model.UpdateByUserId = this.user.userid;

    const saveResult = await FetchData(
      "/saveworkorder",
      "POST",
      this.user.token,
      model,
    );

    if (!saveResult || saveResult.message !== "Success") {
      const message =
        saveResult && saveResult.message
          ? saveResult.message
          : "Unable to update workorder";
      return `Workorder ${jobId}: ${message}`;
    }

    return "Success";
  }

  async updateWorkOrders(jobIds, historyTypes, workOrdersById) {
    if (jobIds.length === 0 || historyTypes.length === 0) {
      return "Success";
    }

    const results = await Promise.all(
      jobIds.map((jobId) =>
        this.updateWorkOrder(jobId, historyTypes, workOrdersById[jobId]),
      ),
    );
    const failure = results.find((result) => result !== "Success");

    return failure || "Success";
  }

  keydownHandler(e) {
    if (e.keyCode === 83 && e.altKey) {
      // ALT+S
      e.preventDefault();
      this.onSave();
    }
  }

  async onSave() {
    let model = { ...this.state.model };

    if (model.JobHistory.length === 0) {
      this.handleSaveEventSuccess({
        message: "Please add Job History",
        modal: true,
        color: "warning",
      });
    } else {
      this.props.setFetchingData(true);
      const jobIds = (model.JobIds || '')
        .split(',')
        .map((id) => id.trim())
        .filter((id) => id !== '');

      const requests = [];
      const updateTypes = this.getWorkOrderUpdateTypes(model.JobHistory);
      let preloadedWorkOrders = null;

      if (updateTypes.length > 0) {
        const preloadResult = await this.preloadWorkOrders(jobIds);
        if (preloadResult.error) {
          this.props.setFetchingData(false);
          this.handleSaveEventSuccess({
            message: preloadResult.error,
            modal: true,
            color: "warning",
          });
          return;
        }
        preloadedWorkOrders = preloadResult.workOrdersById;
      }

      jobIds.forEach((jobId) => {
        model.JobHistory.forEach((history) => {
          const formData = new FormData();
          formData.append('EventType', 'insert');
          formData.append('JobHistoryId', null);
          formData.append('JobId', jobId);
          formData.append('JobHistoryName', '');
          formData.append('Description', history.Description || '');
          formData.append('Contact', '');
          formData.append('ContactEmail', '');
          formData.append('FileLocation', '');
          formData.append('FileName', history.FileName || '');
          formData.append('JobHistoryType', history.Type || '');
          formData.append('CreateDateTime', null);
          formData.append('CreateByUserId', this.user.userid);
          formData.append('UpdateByUserId', null);
          formData.append('UpdateDateTime', null);
          formData.append('FormFile', history.FormFile);
          requests.push(
            UploadFile('/savejobhistory', this.user.token, formData),
          );
        });
      });

      try {
        const results = await Promise.all(requests);
        const failure = results.find((result) => result !== 'Success');

        if (failure) {
          this.props.setFetchingData(false);
          this.handleSaveEventSuccess({
            message: failure,
            modal: true,
            color: 'warning',
          });
          return;
        }

        if (updateTypes.length > 0) {
          const updateResult = await this.updateWorkOrders(
            jobIds,
            updateTypes,
            preloadedWorkOrders || {},
          );
          if (updateResult !== "Success") {
            this.props.setFetchingData(false);
            this.handleSaveEventSuccess({
              message: `Job history saved, but workorder update failed: ${updateResult}`,
              modal: true,
              color: "warning",
            });
            return;
          }
        }

        this.props.handleSaveEventSuccess({
          message: 'Success',
          modal: false,
          color: 'success',
          model: model,
        });
      } catch (err) {
        this.props.setFetchingData(false);
        this.handleSaveEventSuccess({
          message: err && err.message ? err.message : 'Unable to save job history.',
          modal: true,
          color: 'warning',
        });
      }
    }
  }

  renderJobNotes(jobHistory) {
    console.log(jobHistory);
    return (
      <WorkOrderAddJobTableDefault
        jobHistory={jobHistory}
        handleRemove={this.handleRemove}
      />
    );
  }

  render() {
    return (
      <div>
        <Modal
          isOpen={this.props.modal}
          toggle={this.props.setModal}
          style={{ height: "500px", width: "800px" }}
          backdrop="static"
        >
          <ModalHeader>Add Note</ModalHeader>
          <ModalBody>
            <Row>
              <Col style={{ textAlign: "center" }}>
                <Alert
                  color={this.state.alert.color}
                  isOpen={this.state.alert.isOpen}
                >
                  {this.state.alert.message}
                </Alert>
              </Col>
            </Row>
            <Row>
              <Col className="col-12">
                <InputGroup size="sm">
                  <InputGroupText style={{ width: "50px" }}>
                    Job(s):
                  </InputGroupText>
                  <Input
                    name="JobNumbers"
                    className="form-control form-control-text"
                    value={this.state.model.JobNumbers}
                    onChange={this.handleChange}
                  />
                </InputGroup>
              </Col>
            </Row>
            <Row>
              <Col className="col-3">
                <InputGroup size="sm">
                  <InputGroupText style={{ width: "50px" }}>
                    Type:
                  </InputGroupText>
                  <select
                  name="JobHistoryType"                           // <- match the state key you read later
                  value={this.state.model.JobHistoryType || ""}   // controlled value
                  onChange={(e) => {
                    const model = { ...this.state.model, JobHistoryType: e.target.value };
                    this.setState({ model });
                  }}
                  className="form-control form-control-text"
                  ref={(select) => (this.cboType = select)}
                  >
                    <option value=""></option>
                    <option value="Attachment">Attachment</option>
                    <option value="To Auth Dept">To Auth Dept</option>
                    <option value="To Booking Dept">To Booking Dept</option>
                    <option value="To Conf Dept">To Conf Dept</option>
                    <option value="Job Note">Job Note</option>
                    <option value="Authorization">Authorization</option>
                    <option value="My Job">My Job</option>
                    <option value="Claimant Confirmed">
                      Claimant Confirmed
                    </option>
                    <option value="Int Communication">Int Communication</option>
                    <option value="Int Final Conf">Int Final Conf</option>
                    <option value="Int Cancelation">Int Cancelation</option>
                    <option value="Rep Email">Rep Email</option>
                    <option value="Provider Conf">Provider Conf</option>
                    <option value="Schedule Change">Schedule Change</option>
                    <option value="Scheduling Note">Scheduling Note</option>
                    <option value="Special Billing">Special Billing</option>
                    <option value="Special Handling">Special Handling</option>
                    <option value="Waiting on Call Back">
                      Waiting on Call Back
                    </option>
                    <option value="Transport Requested">
                      Transport Requested
                    </option>
                    <option value="Transport Confirmed">
                      Transport Confirmed
                    </option>
                    <option value="Remote Clm Conf">Remote Clm Conf</option>
                    <option value="Remote Int Conf">Remote Int Conf</option>
                    <option value="Remote Prov Conf">Remote Prov Conf</option>
                  </select>
                </InputGroup>
              </Col>
              <Col className="col-6">
                <InputGroup size="sm">
                  <InputGroupText size="sm" color="blue">
                    Description:
                  </InputGroupText>
                  <textarea
                    name="Description"
                    rows="7"
                    className="no-border form-control-text"
                    style={{ width: "100%" }}
                    ref={(textarea) => {
                      this.txtDescription = textarea;
                    }}
                  ></textarea>
                </InputGroup>
              </Col>
              <Col className="col-2">
                <InputGroup size="sm">
                  <Button color="btn" size="sm" onClick={this.addJobHistory}>
                    <img
                      src={AddIcon}
                      style={{ width: "16px", height: "16px" }}
                      alt="Add"
                    />{" "}
                    Add
                  </Button>
                </InputGroup>
              </Col>
            </Row>
            <hr />
            {this.state.model.JobHistoryType === 'Attachment' && <hr />}
            {this.state.model.JobHistoryType === 'Attachment' && (
              <Row>
                <Col className={'col-2'} />
                <Col
                  className={
                    this.state.model.FileName === '' ? 'col-10' : 'col-10'
                  }
                >
                  <div style={{ left: '5px', top: '30px', position: 'relative' }}>
                    <input
                      id="file"
                      type="file"
                      name="fileUpload"
                      onChange={this.handleFileChange}
                      ref={el => (this.fileUpload = el)}
                      // visually hide, but keep it on top to capture clicks/drops
                      style={{
                        position: 'absolute',
                        inset: 0,
                        opacity: 0,
                        width: '100%',
                        height: '100%',
                        cursor: 'pointer',
                        zIndex: 2
                      }}
                    />

                    <label
                      htmlFor="file"
                      className="form-control d-flex align-items-center justify-content-center"
                      style={{
                        minHeight: 100,
                        border: '1px dashed #ccc',
                        borderRadius: 6,
                        margin: 0,
                        cursor: 'pointer',
                        zIndex: 1
                      }}
                    >
                      {this.state.model.FileName || 'Drag and Drop'}
                    </label>
                  </div>
                </Col>
                <Col className="col-1">
                  <img
                    src={DeleteIcon}
                    style={{
                      width: '14px',
                      height: '14px',
                      cursor: 'pointer',
                      display: this.state.model.FileName === '' ? 'none' : null,
                    }}
                    onClick={this.handleDeleteFile}
                    alt="Delete"
                  />
                </Col>
              </Row>
            )}
            <hr />
            <b>Job History</b>
            <Row>
              <Col>{this.renderJobNotes(this.state.model.JobHistory)}</Col>
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button onClick={this.props.setModal} size="sm">
              Cancel
            </Button>
            <Button
              color="primary"
              onClick={() => {
                this.onSave();
              }}
              className="btn"
              size="sm"
            >
              Save
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}
